var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActivityIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_18084)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(0.388672 0.253906)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3904 13.7984C13.7973 13.7984 16.5592 11.0366 16.5592 7.62968C16.5592 4.22278 13.7973 1.46094 10.3904 1.46094C6.98352 1.46094 4.22168 4.22278 4.22168 7.62968C4.22168 11.0366 6.98352 13.7984 10.3904 13.7984Z",
    stroke: "#424450",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9755 13.5888C17.8564 5.057 10.3906 1.46094 10.3906 1.46094",
    stroke: "#424450",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83444 13.5898C3.87031 6.38346 8.42224 2.69856 9.95732 1.72848C10.1847 1.58279 10.4868 1.7036 10.5472 1.97011C10.8812 3.43767 11.6665 7.96473 10.3873 13.7994",
    stroke: "#424450",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7998 11.7461L8.21258 16.1168H12.3097L14.6763 12.0623",
    stroke: "#424450",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8551 16.1191H8.66773C8.41653 16.1191 8.21289 16.3228 8.21289 16.574V18.5923C8.21289 18.8435 8.41653 19.0472 8.66773 19.0472H11.8551C12.1063 19.0472 12.31 18.8435 12.31 18.5923V16.574C12.31 16.3228 12.1063 16.1191 11.8551 16.1191Z",
    stroke: "#424450",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3906 13.793V16.1169",
    stroke: "#424450",
    strokeWidth: 0.604082,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_18084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.388672 0.253906)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityIcon);
export default __webpack_public_path__ + "static/media/activity_icon.c326c0bbc363cd9d239b28822ad99e58.svg";
export { ForwardRef as ReactComponent };